<div class="flex w-full justify-center">
  @if (errorFetchingInvoice) {
    <div class="text-error">
      <p>{{ errorFetchingInvoice }}</p>
    </div>
  } @else if (errorFetchingPaymentDetails) {
    <div class="text-error">
      <p>{{ errorFetchingPaymentDetails }}</p>
    </div>
  } @else if (loadingInvoice || loadingPaymentDetails) {
    <div class="flex w-full justify-center">
      <div class="skeleton mt-5 h-96 w-full max-w-3xl"></div>
    </div>
  } @else if (hasOrder && tenant) {
    <div
      id="receipt-wrapper"
      class="mt-5 hidden w-full max-w-4xl rounded-md border-2 border-base-content/20 p-4 sm:block print:border-none print:p-0"
    >
      <div class="flex flex-col justify-between sm:flex-row">
        <div>
          <p class="mb-4 text-4xl">Receipt</p>
          <div class="flex flex-col text-sm sm:flex-row">
            <div class="sm:mr-12">
              <div class="table-row">
                <p class="table-cell pb-1 pr-3 text-right text-base-content/70">
                  Account #:
                </p>
                <div class="table-cell pb-1">{{ tenant.account_number }}</div>
              </div>
              <div class="table-row">
                <p class="table-cell pb-1 pr-3 text-right text-base-content/70">
                  Company:
                </p>
                <div class="table-cell pb-1">{{ tenant.company }}</div>
              </div>
              <div class="table-row">
                <p class="table-cell pb-1 pr-3 text-right text-base-content/70">
                  Order #:
                </p>
                <div class="table-cell pb-1">
                  {{ orderNumber }}
                </div>
              </div>
              @if (isAdmin && successfulPayment && currentView === 'admin') {
                <div class="table-row">
                  <p
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    Authorize.net ID:
                  </p>
                  <div class="table-cell pb-1">
                    <span
                      class="text-link cursor-pointer print:hidden"
                      (click)="
                        openAuthorizeNetPayment(successfulPayment.trans_id)
                      "
                      >{{ successfulPayment.trans_id }}</span
                    >
                    <span class="screen:hidden">{{
                      successfulPayment.trans_id
                    }}</span>
                    <span
                      class="tooltip top-[3px] ml-2 w-4 print:hidden"
                      data-tip="Opens the Authorize.net search page with the ID
                automatically copied to your clipboard, so you can paste it
                into the search field."
                    >
                      <app-info-circle-icon></app-info-circle-icon>
                    </span>
                  </div>
                </div>
                <div class="table-row">
                  <p
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    QBO Invoice:
                  </p>
                  <div class="table-cell pb-1">
                    @if (quickbooksInvoiceId) {
                      <a
                        class="text-link print:hidden"
                        [href]="getQuickbooksInvoiceLink(quickbooksInvoiceId)"
                        target="_blank"
                        >{{ quickbooksInvoiceId }}</a
                      >
                      <span class="screen:hidden">{{
                        quickbooksInvoiceId
                      }}</span>
                    } @else {
                      <div class="flex items-center gap-2">
                        <span class="text-error">QBO Invoice Missing</span>
                        <span
                          class="relative top-[3px] ml-2 inline-block w-4 cursor-pointer rounded print:hidden"
                          (click)="refreshInvoice()"
                        >
                          <app-refresh-icon class="h-4 w-4"></app-refresh-icon>
                        </span>
                      </div>
                    }
                  </div>
                </div>
                <div class="table-row">
                  <p
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    QBO Payment:
                  </p>
                  <div class="table-cell pb-1">
                    @if (quickbooksPaymentId) {
                      <a
                        class="text-link print:hidden"
                        [href]="getQuickbooksPaymentLink(quickbooksPaymentId)"
                        target="_blank"
                        >{{ quickbooksPaymentId }}</a
                      >
                      <span class="screen:hidden">{{
                        quickbooksPaymentId
                      }}</span>
                    } @else {
                      <div>
                        <span class="text-error print:hidden">
                          Payment not yet recorded
                        </span>
                        <span class="screen:hidden">
                          Payment not yet recorded
                        </span>
                        <span
                          class="relative top-[3px] ml-2 inline-block w-4 cursor-pointer rounded print:hidden"
                          (click)="refreshInvoice()"
                        >
                          <app-refresh-icon class="h-4 w-4"></app-refresh-icon>
                        </span>
                      </div>
                    }
                  </div>
                </div>
              @if (!isDES) {
                <div class="table-row">
                  <p
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    Sales Rep:
                  </p>
                  <div class="table-cell pb-1">
                    {{
                      getSalesRepNames(
                        desktopInvoice
                          ? desktopInvoice.sales_reps
                          : apiInvoice!.sales_reps
                      )
                    }}
                  </div>
                </div>
              }
              }
              <div class="table-row">
                <p class="table-cell pb-1 pr-3 text-right text-base-content/70">
                  Completed on:
                </p>
                <div class="table-cell pb-1">
                  @if (orderCompletedAt) {
                    {{ orderCompletedAt | date: 'MM/dd/yyyy, hh:mmaa' }}
                  }
                </div>
              </div>
              @if (
                desktopPaymentDetails || apiPaymentDetails || desPaymentDetails
              ) {
                <div class="table-row">
                  <p
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    Payment method:
                  </p>
                  <div class="table-cell pb-1">
                    {{ displayPaymentMethod }}
                  </div>
                </div>
              }
              <div class="table-row">
                <p class="table-cell pb-1 pr-3 text-right text-base-content/70">
                  Amount paid:
                </p>
                <div class="table-cell pb-1">
                  {{ orderTotal | currency: 'USD' }}
                </div>
              </div>
            </div>
            <div>
              <div class="table-row">
                <p class="table-cell pb-1 text-base-content/70">
                  Shipping Address:
                </p>
              </div>
              <div class="sm:table-row">
                <div class="table-cell max-w-60 pb-2">
                  <p>{{ tenant.address }} {{ tenant.address2 }}</p>
                  <p>{{ tenant.city }}, {{ tenant.st }} {{ tenant.zip }}</p>
                </div>
              </div>
              @if (tenant.billing_address) {
                <div class="table-row">
                  <p class="table-cell pb-1 text-base-content/70">
                    Billing Address:
                  </p>
                </div>
                <div class="sm:table-row">
                  <div class="table-cell max-w-60 pb-2">
                    <p>
                      {{ tenant.billing_address }} {{ tenant.billing_address2 }}
                    </p>
                    <p>
                      {{ tenant.billing_city }}, {{ tenant.billing_st }}
                      {{ tenant.billing_zip }}
                    </p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="hidden h-24 w-24 sm:block">
          <app-file-invoice-icon
            class="text-gray-600 dark:text-gray-300 print:hidden [&_path]:stroke-1"
          ></app-file-invoice-icon>
          <img
            src="assets/accuzip-logo-colored.png"
            alt="AccuZIP Logo"
            class="h-full screen:hidden"
          />
          <p
            class="link text-center text-sm print:hidden"
            (click)="printReceipt()"
          >
            Print Receipt
          </p>
        </div>
      </div>

      <!-- Licenses/Products table -->
      <div class="mt-4 overflow-x-auto">
        <table class="table table-zebra">
          <thead class="text-sm">
            @if (desktopInvoice) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Type</th>
                @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                  <th class="font-medium">Duration</th>
                }
                <th class="font-medium">New Expiration</th>
                <th class="font-medium">Quantity</th>
                <th class="text-right font-medium">Price</th>
                <th class="text-right font-medium">Total</th>
              </tr>
            } @else if (desPurchase) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Credits</th>
                <th class="font-medium">Price / 1,000</th>
                <th class="text-right font-medium">Total</th>
              </tr>
            } @else if (apiInvoice && apiProduct) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Transaction Month</th>
                <th class="font-medium">Job Count</th>
                <th class="text-right font-medium">Price</th>
                <th class="text-right font-medium">Total</th>
              </tr>
            }
          </thead>
          <tbody>
            @if (desktopInvoice) {
              @for (el of groupedLicenses; track el) {
                <tr>
                  <td
                    [class]="{
                      'pr-4':
                        el.license.license_with_product
                          .parent_desktop_license_id,
                    }"
                  >
                    {{ el.license.license_with_product.product.title }}
                  </td>
                  <td>
                    {{ getLicenseType(el.license.license_with_product) }}
                  </td>
                  @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                    <td>
                      {{
                        el.license.license_with_product.product_variant
                          .display_duration
                      }}
                    </td>
                  }
                  <td>
                    {{
                      el.license.new_expiration_date
                        | date: 'MM/dd/yyyy' : 'UTC'
                    }}
                  </td>
                  <td>{{ el.count }}</td>
                  <td class="text-right">
                    {{ el.license.base_amount | currency: 'USD' }}
                  </td>
                  <td class="text-right">
                    {{ el.license.base_amount * el.count | currency: 'USD' }}
                  </td>
                </tr>
              }
            } @else if (desPurchase) {
              <tr>
                <td>DES Credits</td>
                <td>{{ desPurchase.credits | number }}</td>
                <td>{{ desPricePerThousand | currency: 'USD' }}</td>
                <td class="text-right">
                  {{ desPurchase.total_amount | currency: 'USD' }}
                </td>
              </tr>
            } @else if (apiInvoice && apiProduct) {
              <tr>
                <td>{{ apiProduct.title }}</td>
                <td>
                  {{
                    getDisplayTransactionMonth(
                      apiInvoice.api_invoice.transaction_yyyymm
                    ) | date: 'MMMM, yyyy'
                  }}
                </td>
                <td>{{ apiInvoice.api_invoice.job_count }}</td>
                <td class="text-right">
                  {{ apiInvoice.api_invoice.base_amount | currency: 'USD' }}
                </td>
                <td class="text-right">
                  {{ apiInvoice.api_invoice.base_amount | currency: 'USD' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="w-100 mt-4 flex">
        @if (desktopInvoice?.desktop_invoice?.notes) {
          <div class="pl-4 text-sm">
            <p class="pb-0 pr-3 text-base-content/70">Memo:</p>
            <p class="mt-1 whitespace-pre-wrap">
              {{ desktopInvoice?.desktop_invoice?.notes }}
            </p>
          </div>
        }
        <div class="ml-auto w-48">
          <table class="table table-sm">
            <tbody>
              <tr>
                <td>Subtotal:</td>
                <td class="pr-4 text-right">
                  {{ orderBase | currency: 'USD' }}
                </td>
              </tr>
              <tr>
                <td>Tax:</td>
                <td class="pr-4 text-right">
                  {{ orderTax | currency: 'USD' }}
                </td>
              </tr>
              <tr>
                <td>Total:</td>
                <td class="pr-4 text-right">
                  {{ orderTotal | currency: 'USD' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mb-4 mt-8 flex flex-col items-center print:hidden">
        <div class="form-control w-full max-w-sm">
          <div class="flex flex-col gap-4">
            <div class="flex flex-col items-center print:hidden">
              <button
                class="btn btn-outline my-4 w-full"
                (click)="openEmailReceiptDialog()"
              >
                Email Receipt
              </button>
              @if (isAdmin && currentView === 'admin') {
                @if (apiInvoice) {
                  <button
                    class="btn btn-outline my-4 w-full"
                    [routerLink]="[
                      '/admin/tenant/' + tenant.id + '/api-job-logs',
                    ]"
                    [queryParams]="{
                      month: apiInvoice.api_invoice.transaction_yyyymm,
                    }"
                  >
                    Go to Job Logs
                  </button>
                }
                <button
                  class="btn btn-outline my-4 w-full"
                  [routerLink]="'/admin/tenant/' + tenant.id"
                >
                  Back to Tenant
                </button>
              } @else {
                @if (desktopInvoice) {
                  <button
                    class="btn btn-outline my-4 w-full"
                    [routerLink]="'/receipts'"
                  >
                    Go to Receipts
                  </button>
                } @else if (apiInvoice) {
                  <button
                    class="btn btn-outline my-4 w-full"
                    [routerLink]="['/api-job-logs']"
                    [queryParams]="{
                      month: apiInvoice.api_invoice.transaction_yyyymm,
                      tenant_id: isAdmin ? tenant.id : null,
                    }"
                  >
                    Go to Job Logs
                  </button>
                  <button
                    class="btn btn-outline my-4 w-full"
                    [routerLink]="'/api-invoices'"
                  >
                    Go to API Invoices
                  </button>
                }
                <button class="btn btn-outline my-4 w-full" [routerLink]="'/'">
                  Go to Dashboard
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Receipt -->
    <div class="w-full sm:hidden">
      <div class="prose">
        <h1 class="mb-4">Receipt</h1>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Account #:</p>
        <div class="pb-1 text-right">{{ tenant.account_number }}</div>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Company:</p>
        <div class="pb-1">{{ tenant.company }}</div>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Order #:</p>
        <div class="pb-1">
          {{ orderNumber }}
        </div>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Completed on:</p>
        <div class="pb-1">
          {{ orderCompletedAt | date: 'MM/dd/yyyy, hh:mmaa' }}
        </div>
      </div>
      @if (desktopPaymentDetails || apiPaymentDetails || desPaymentDetails) {
        <div class="flex justify-between">
          <p class="pb-1 pr-3 text-base-content/70">Payment method:</p>
          <div class="pb-1">
            {{ displayPaymentMethod }}
          </div>
        </div>
      }
      <div class="flex justify-between">
        <p class="pr-3 text-base-content/70">Amount paid:</p>
        <div>
          {{ orderTotal | currency: 'USD' }}
        </div>
      </div>
      <div class="my-4 w-full border-2 border-base-content/50"></div>
      <div>
        <p class="mb-4 text-xl font-bold">Products</p>
        @if (desktopInvoice) {
          @for (el of groupedLicenses; track el) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ el.license.license_with_product.product.title }}</p>
              </div>
              @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                <div class="flex">
                  <p class="pb-1 pr-3 text-base-content/70">Duration:</p>
                  <p>
                    {{
                      el.license.license_with_product.product_variant
                        .display_duration
                    }}
                  </p>
                </div>
              }
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">New Expiration:</p>
                <p>
                  {{
                    el.license.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                  }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>{{ getLicenseType(el.license.license_with_product) }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Quantity:</p>
                <p>{{ el.count }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Price:</p>
                <p>{{ el.license.base_amount | currency: 'USD' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Total:</p>
                <p>
                  {{ el.license.base_amount * el.count | currency: 'USD' }}
                </p>
              </div>
            </div>
          }
        } @else if (desPurchase) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Product:</p>
              <p>DES Credits</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Credits:</p>
              <p>{{ desPurchase.credits | number }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Price / 1,000:</p>
              <p>{{ desPricePerThousand | currency: 'USD' }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Total:</p>
              <p>{{ desPurchase.total_amount | currency: 'USD' }}</p>
            </div>
          </div>
        } @else if (apiInvoice && apiProduct) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Product:</p>
              <p>{{ apiProduct.title }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Transaction Month:</p>
              <p>
                {{
                  getDisplayTransactionMonth(
                    apiInvoice.api_invoice.transaction_yyyymm
                  ) | date: 'MMMM, yyyy'
                }}
              </p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Job Count:</p>
              <p>{{ apiInvoice.api_invoice.job_count }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Price:</p>
              <p>{{ apiInvoice.api_invoice.base_amount | currency: 'USD' }}</p>
            </div>
          </div>
        }
      </div>
      <div class="my-4 w-full border-2 border-base-content/20"></div>
      <p class="mb-2 text-xl font-bold">Address Info</p>
      <div class="mt-2 flex flex-col">
        <p class="pb-1 pr-3 text-lg font-medium text-base-content/70">
          Shipping Address
        </p>
        <div class="pb-1">
          {{ tenant.address }}, {{ tenant.address2 }}, {{ tenant.city }},
          {{ tenant.st }}, {{ tenant.zip }}
        </div>
      </div>
      @if (tenant.billing_address) {
        <div class="flex flex-col">
          <p class="pb-1 pr-3 text-lg font-medium text-base-content/70">
            Billing Address
          </p>
          <div class="pb-1">
            {{ tenant.billing_address }}, {{ tenant.billing_address2 }},
            {{ tenant.billing_city }}, {{ tenant.billing_st }},
            {{ tenant.billing_zip }}
          </div>
        </div>
      }
      @if (desktopInvoice?.desktop_invoice?.notes) {
        <div class="my-4 w-full border-2 border-base-content/20"></div>
        <div>
          <p class="mb-2 text-xl font-bold">Memo</p>
          <div class="mt-2">
            <p class="whitespace-pre-wrap">
              {{ desktopInvoice?.desktop_invoice?.notes }}
            </p>
          </div>
        </div>
      }
      <div class="my-4 w-full border-2 border-base-content/20"></div>
      <p class="mb-2 text-xl font-bold">Order Summary</p>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Subtotal:</p>
        <div class="pb-1 text-right">
          {{ orderBase | currency: 'USD' }}
        </div>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Tax:</p>
        <div class="pb-1 text-right">
          {{ orderTax | currency: 'USD' }}
        </div>
      </div>
      <div class="flex justify-between">
        <p class="pb-1 pr-3 text-base-content/70">Total:</p>
        <div class="pb-1 text-right">
          {{ orderTotal | currency: 'USD' }}
        </div>
      </div>
      <button class="btn btn-primary mt-4 w-full" (click)="printReceipt()">
        Print Receipt
      </button>
    </div>
  }
</div>

<dialog #emailReceiptDialog class="modal">
  <div class="modal-box w-full max-w-xl p-8">
    <h3 class="text-lg font-bold">Send Receipt to Emails</h3>
    <!-- <label class="label">
        <span class="label-text">Send Receipt to Email(s)</span>
      </label> -->
    <div class="mt-4 rounded-lg border border-base-content/20">
      <div class="overflow-y-auto">
        @if (accountEmails.length > 0) {
          <div class="pl-4 pt-2">Account Emails:</div>
          @for (email of accountEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.includes(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }
        @if (billingEmails.length > 0) {
          <div class="pl-4 pt-2">Billing Emails:</div>
          @for (email of billingEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.includes(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }

        @if (additionalEmails.length > 0) {
          <div class="pl-4 pt-2">Additional Emails:</div>
          @for (email of additionalEmails; track email) {
            <div>
              <label
                class="flex cursor-pointer items-center gap-2 px-4 py-2 hover:bg-base-200"
              >
                <input
                  type="checkbox"
                  class="checkbox-primary checkbox"
                  [checked]="selectedEmails.includes(email)"
                  (change)="toggleEmail(email)"
                />
                <span>{{ email }}</span>
              </label>
            </div>
          }
        }

        <div>
          @if (!isAddingEmail) {
            <button
              class="flex w-full items-center gap-2 px-4 py-2 text-left hover:bg-base-200"
              (click)="startAddingEmail()"
            >
              <app-plus-icon class="h-4 w-4"></app-plus-icon>
              <span>Add another email</span>
            </button>
          } @else {
            <div class="flex w-full px-4 py-2">
              <div class="join flex w-full">
                <input
                  type="email"
                  class="input input-sm join-item input-bordered flex-1"
                  placeholder="Enter email address"
                  [formControl]="customEmail"
                  (keyup.enter)="addCustomEmail()"
                  (keyup.escape)="cancelAddingEmail()"
                  #emailInput
                />
                <button
                  class="btn btn-outline btn-primary join-item btn-sm"
                  (click)="addCustomEmail()"
                >
                  Add
                </button>
                <button
                  class="btn btn-outline btn-error join-item btn-sm"
                  (click)="cancelAddingEmail()"
                >
                  Cancel
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="mt-8 flex justify-center space-x-4">
      <button
        class="btn btn-primary"
        (click)="sendReceipt()"
        [disabled]="!isValidEmail() || emailSending"
      >
        Send Emails
      </button>
      <button
        class="btn btn-error"
        (click)="closeEmailReceiptDialog()"
        [disabled]="emailSending"
      >
        Cancel
      </button>
    </div>

    @if (emailError) {
      <label class="label mt-4 flex justify-center">
        <span class="label-text text-error">{{ emailError }}</span>
      </label>
    } @else if (emailSending) {
      <div class="mt-4 flex justify-center">
        <span class="loading loading-spinner w-9"></span>
      </div>
    }
  </div>
</dialog>
